import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1834264613/src/skop-manage/src/app/[locale]/(restricted)/RestrictedShell.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/BlueprintContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/CatalogEditorContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/DataContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/DrawerContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/NavbarContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/PublicAppProviders.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/QuoteContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/RestrictedAppProviders.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/ReviewContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/SessionRuntimeContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/context/UserContext.tsx");
